(function () {
  function setup(el) {
    var track = el.querySelector('.v2g-announce-ticker__track');
    if (!track || track.dataset.duplicated) return;
    track.dataset.duplicated = 'true';

    var original = Array.prototype.slice.call(track.children);
    if (!original.length) return;

    original.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      if (clone.tagName === 'A') clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });

    // Force layout before enabling the animation so there's no flash of
    // the (now double-width) track jumping to its animated start position.
    void track.offsetWidth;
    track.classList.add('is-ready');
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-v2g-announce-ticker]').forEach(setup);
  });
})();
